export enum LengthUnit {
    CM = 'cm',
    IN = 'in'
}